<template>
  <v-container style="max-width: 480px; padding-top: 4rem">
    <v-card color="surface" class="pa-8">
      <div class="text-center mb-6">
        <v-icon color="primary" size="48" class="mb-2">mdi-lock-check</v-icon>
        <h1 class="text-h5 font-weight-bold">Nulstil adgangskode</h1>
        <p class="text-body-2 text-grey">Vælg en ny adgangskode.</p>
      </div>

      <v-form v-if="!done" @submit.prevent="handleReset">
        <v-text-field
          v-model="password"
          label="Ny adgangskode"
          :type="showPw ? 'text' : 'password'"
          prepend-inner-icon="mdi-lock-outline"
          :append-inner-icon="showPw ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showPw = !showPw"
          :rules="[
            (v) => !!v || 'Adgangskode er påkrævet',
            (v) => v.length >= 8 || 'Mindst 8 tegn',
          ]"
          class="mb-4"
        />
        <v-btn type="submit" color="primary" size="large" block :loading="loading">
          Gem ny adgangskode
        </v-btn>
      </v-form>

      <v-alert v-if="done" type="success" variant="tonal">
        Din adgangskode er nulstillet.
        <router-link to="/login" class="text-primary font-weight-bold">Log ind</router-link>
      </v-alert>

      <v-alert
        v-if="error"
        type="error"
        variant="tonal"
        class="mt-4"
        density="compact"
      >
        {{ error }}
      </v-alert>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "../stores/auth";

const route = useRoute();
const auth = useAuthStore();

const password = ref("");
const showPw = ref(false);
const loading = ref(false);
const done = ref(false);
const error = ref("");

async function handleReset() {
  error.value = "";
  loading.value = true;
  try {
    await auth.resetPassword(route.query.token, password.value);
    done.value = true;
  } catch (e) {
    error.value = e.response?.data?.error || "Nulstilling fejlede";
  } finally {
    loading.value = false;
  }
}
</script>
